import Chart from "react-apexcharts";
import React, { useState } from "react";
import styled from "styled-components";
import { VscCircleFilled } from "react-icons/vsc";
import { kFormatter2, kFormatter3 } from "utils/format";
import { AppButton, AppModal, FormInput, FormSelect } from "components";
import { checked, warning } from "assets/icons";
import { ApiService } from "services";
import toast from "react-hot-toast";
import { Router } from "utils/route";
const TodayTransactionsChartSingle = ({ options, countAmount, data }) => {
  //const colors = ["#01A926", "#FE0004", "#F9C74F"];
  const [modal, setModal] = useState();
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(0);

  //eslint-disable-next-line
  const [details, setDetails] = useState({ email: "", route: "", maxVal: "" });

  const emailTriggerInstitution = async () => {
    setLoading(true);
    try {
      const data = await ApiService.emailTrigger(details);
      setStep(2);
      setLoading(false);

      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  console.log(details);

  const { route } = Router();
  return (
    <NewStyle>
      <div className="trigger">
        <AppButton
          placeholder="Configure Trigger"
          onClick={() => {
            setModal(true);
            route("/configurations");
          }}
        />
      </div>
      <div className="chart_board">
        <div className="chart_board_direct">
          <div className="chart_board_direct_inner">
            <div
              style={{
                fontSize: "1.9vw",
                color: "#019EDF",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              Direct
            </div>
            <br />
            <div className="chart_header">Approved</div>
            <div className="chart_inner">
              <br />

              <div>
                Amount: {kFormatter3(data[3]?.direct_success_amount || 0)}
              </div>
              <br />

              <div>
                Count: {kFormatter2(data[3]?.direct_success_count || 0)}
              </div>
            </div>{" "}
          </div>

          <div className="chart_board_direct_inner">
            <hr style={{ width: "100%" }} />
            <br />
            <div className="chart_header">Declined</div>
            <div className="chart_inner">
              <br />
              <div>
                Amount: {kFormatter3(data[3]?.direct_failed_amount || 0)}
              </div>
              <br />
              <div>Count: {kFormatter2(data[3]?.direct_failed_count || 0)}</div>
            </div>{" "}
          </div>
        </div>
        <div className="chart" style={{ position: "relative" }}>
          <Chart
            series={options.series}
            options={options.options}
            type="donut"
            width={"140%"}
          />
          <div
            style={{
              color: "black",
              position: "absolute",
              top: "54%",
              left: "0%",
              transform: "translateY(-60%)",
              width: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div style={{ fontSize: "1.4vw", fontWeight: "600" }}>COUNT</div>
            <p
              style={{
                color: "black",
                fontSize: "2.4vw",
                marginTop: "-1px",
                fontWeight: "600",
              }}
            >
              {countAmount}
            </p>
          </div>
        </div>
        <div className="chart_board_direct">
          <div className="chart_board_direct_inner">
            <div
              style={{
                fontSize: "1.9vw",
                color: "#019EDF",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              NIP
            </div>
            <br />
            <div className="chart_header">Approved</div>
            <div className="chart_inner">
              <br />

              <div>Amount: {kFormatter3(data[3]?.nip_success_amount || 0)}</div>
              <br />

              <div>Count: {kFormatter2(data[3]?.nip_success_count || 0)}</div>
            </div>{" "}
          </div>
          <div className="chart_board_direct_inner">
            <hr style={{ width: "100%" }} />
            <br />
            <div className="chart_header">Declined</div>
            <div className="chart_inner">
              <br />

              <div>Amount: {kFormatter3(data[3]?.nip_failed_amount || 0)}</div>
              <br />

              <div>Count: {kFormatter2(data[3]?.nip_failed_count || 0)}</div>
            </div>{" "}
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "1000px",
          marginTop: "40px",
          marginRight: "auto",
          paddingLeft: "20px",
          paddingBottom: "40px",
          fontSize: "20px",
        }}
      >
        <div style={{ display: "flex" }}>
          <VscCircleFilled style={{ color: "#01A926" }} size={30} />
          <div>
            Successful
            <div>Amount: {kFormatter3(data[1]?.successfulAmount)}</div>
            <div>Count: {kFormatter2(data[1]?.successfulCount)}</div>
          </div>
        </div>
        <br></br>
        <div style={{ display: "flex" }}>
          <VscCircleFilled style={{ color: "#FE0004" }} size={30} />
          <div>
            Failed
            <div>Amount: {kFormatter3(data[2]?.failedAmount)}</div>
            <div>Count: {kFormatter2(data[2]?.failedCount)}</div>
          </div>
        </div>
        <br></br>

        <div style={{ display: "flex" }}>
          <VscCircleFilled style={{ color: "#F9C74F" }} size={30} />
          <div>
            Pending
            <div
              style={{
                display: "flex",
              }}
            >
              Amount: {kFormatter3(data[0]?.pendingAmount)}
            </div>
            <div>Count: {kFormatter2(data[0]?.pendingCount)}</div>
          </div>
        </div>
      </div>

      {modal && (
        <div>
          {step === 0 && (
            <AppModal
              maxWidth={"700px"}
              closeModal={() => {
                setModal(false);
                setStep(0);
              }}
              headingSize="21px"
              heading={<> Configure Email Trigger</>}
            >
              <div>
                <FormInput
                  type="number"
                  label="Max Value"
                  placeholder="Max Value"
                />
              </div>
              <div>
                <FormSelect placeholder="routes" label="Route" />
              </div>
              <div>
                <FormInput type="text" placeholder="Secs" label="Add Emails" />
              </div>
              <AppButton
                onClick={() => {
                  if (details) {
                    setStep(1);
                  } else {
                    toast.error("Fill Configuration Fields");
                  }
                }}
                placeholder="Set Cofiguration"
              />
              &nbsp; &nbsp;
              <AppButton
                onClick={() => {
                  setModal(false);
                  setStep(0);
                }}
                outline
                placeholder="Cancel"
              />
            </AppModal>
          )}
          {step === 1 && (
            <AppModal
              closeModal={() => {
                setModal(false);
                setStep(0);
              }}
            >
              <div>
                <img src={warning} alt="" />
                <h3>Confirm Changes</h3>
              </div>
              <p style={{ margin: "30px 0" }}>
                Are you sure you want to set this configuration?
              </p>
              <div style={{ display: "flex" }}>
                <AppButton
                  onClick={() => {
                    setModal(false);
                    setStep(0);
                  }}
                  outline
                  placeholder="Cancel"
                />
                &nbsp; &nbsp; &nbsp; &nbsp;
                <AppButton
                  onClick={() => {
                    emailTriggerInstitution();
                  }}
                  placeholder="Confirm"
                  loading={loading}
                  disabled={loading}
                />
              </div>
            </AppModal>
          )}
          {step === 2 && (
            <AppModal
              closeModal={() => {
                setModal(false);
                setStep(0);
              }}
            >
              <div>
                <img src={checked} alt="" />
                <h3>Changes saved</h3>
              </div>
              <p style={{ margin: "30px 0" }}>Successfully configured.</p>
            </AppModal>
          )}
        </div>
      )}
    </NewStyle>
  );
};

export default TodayTransactionsChartSingle;

const NewStyle = styled.div`
  .apexcharts-legend {
    flex-direction: column;
    justify-content: center !important;
    bottom: 0 !important;
    width: 30%;
    margin: 0 auto;
  }
  .trigger {
    padding: 0 30px;
    width: 200px;
    margin-left: auto;
  }
  .chart_board {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 60px 0;
    padding: 0 30px;
    height: auto;
    width: 97%;

    .chart {
      width: 90%;
      margin: 0 auto;
    }
    .chart_header {
      font-size: 2.4vw;
      font-weight: 600;
      text-align: center;
    }
    .chart_inner {
      font-size: 1.8vw;
      font-weight: 600;
    }
    .chart_board_direct {
      border: 1.2px solid #363636;
      width: 100%;
      border-radius: 10px;
      display: grid;
      grid-template-columns: 1fr;
      padding: 26px;
      .chart_board_direct_inner {
        width: 100%;
      }
    }
  }
`;
